import { ContactDataDisplayModel } from "@/api/models/ace/xFound/Portal/Core/CAQ/Models/contact-data-display-model";
import { AnfrageService } from "@/api/service-index";
import { UnfinishedHttpMethodsService } from "@/core/services/unfinished-http-methods.service";
import { PortalContextService } from "@/core/services/portal-context.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from "@angular/router";
import { of } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
  })
  export class GetAnfrageContactDataResolver implements Resolve<ContactDataDisplayModel | undefined> {
    constructor(protected anfrageService: AnfrageService, protected portalContextService: PortalContextService, protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService){}
  
    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ContactDataDisplayModel | undefined> {
      let id: string = <string>route.params['id'];

      if (this.portalContextService.CurrentGutachten) {
        id = this.portalContextService.CurrentAnfrage.id;
      }

      await this.unfinishedHttpMethodsService.waitByUrl(state.url);

      if(this.portalContextService.CurrentAnfrage && this.portalContextService.CurrentAnfrage.id == id && this.portalContextService.CurrentAnfrage.contactData)
        return of(this.portalContextService.CurrentAnfrage.contactData).toPromise();
    
      return this.anfrageService.apiAnfrageAnfrageIdContactDataGet({ anfrageId: id }).pipe(map(response => {        
        if (response) {
          if(this.portalContextService.CurrentAnfrage?.id == id && !this.portalContextService.CurrentAnfrage?.contactData)
            this.portalContextService.CurrentAnfrage.contactData = response;

          if(this.portalContextService.CurrentAnfrage?.contactData)
            return this.portalContextService.CurrentAnfrage.contactData;
        }

        return undefined;
      })).toPromise();
    }
  }